module.exports = __webpack_public_path__ + "static/media/Milex-Donut-Pessary-Instructions-for-Use@3x.7c0da53f.jpg";